import { ajax } from 'utils';
import { apiVersionCheck } from '@mpc/common/src/utils/versionCheck';
import * as commonApi from './api';

export const outsourceSessionsLogin = (body: any) => 
  apiVersionCheck() ?
    commonApi.outsourceSessionsLogin(body, { toRubby: true })
    :
    ajax({
      url: 'outsource/sessions',
      method: 'POST',
      body,
    }, false)

export const outsourceSessionsLoginOut = () => 
  apiVersionCheck(3) ?
    commonApi.outsourceSessionsLoginOut({ toRubby: true })
    :
    ajax({
      url: 'outsource/sessions',
      method: 'DELETE',
    })

export const outsourceSuppliersSetCurrent = (body: any) => 
  apiVersionCheck() ?
  commonApi.outsourceSuppliersSetCurrent(body, { toRubby: true })
  :
  ajax({
    url: 'outsource/v2/suppliers/set_current',
    method: 'POST',
    body,
  }, false)


export const outsourceSessionsModifyPassword = (body: any) => 
  apiVersionCheck() ?
  commonApi.outsourceSessionsModifyPassword(body, { toRubby: true })
  :
  ajax({
    url: 'outsource/sessions/modify_password',
    method: 'POST',
    body,
  }, false)

export const outsourceSessionsForgetPassword = (body: any) => 
  apiVersionCheck() ?
  commonApi.outsourceSessionsForgetPassword(body, { toRubby: true })
  :
  ajax({
    url: 'outsource/sessions/forget_password',
    method: 'POST',
    body,
  }, false)

export const outsourceSessionsCheckResetLink = (body: any) => 
  apiVersionCheck() ?
  commonApi.outsourceSessionsCheckResetLink(body, { toRubby: true })
  :
  ajax({
    url: 'outsource/sessions/check_reset_link',
    method: 'POST',
    body,
  }, false)

export const outsourceSessionsResetPassword = (body: any) => 
  apiVersionCheck() ?
  commonApi.outsourceSessionsResetPassword(body, { toRubby: true })
  :
  ajax({
    url: 'outsource/sessions/reset_password',
    method: 'POST',
    body,
  })

export const outsourceAccountsMenusCount = (body: any) => 
  apiVersionCheck() ?
  commonApi.outsourceAccountsMenusCount({ toRubby: true })
  :
  ajax({
    url: 'v1/accounts/menus_count',
    body,
  })

const convertCommonFilterOptions = (params: any = {}) => {
  params.outsource_state = (params.state || '').toUpperCase();
  delete params.state;
  return params;
}

export const outsourceCommonFilterOptions = (body: any) => 
  apiVersionCheck() ?
  commonApi.outsourceCommonFilterOptions(convertCommonFilterOptions(body), { toRubby: true })
  :
  ajax({
    url: 'v1/common/filter_options',
    method: 'POST',
    body,
  })

export const outsourceAccountsUserInfo = () => 
  apiVersionCheck(3) ?
    commonApi.outsourceAccountsUserInfo({ toRubby: true })
    :
    ajax({
      url: 'v1/accounts/user_info',
    })

export const outsourceAccountsLoginWithUrl = (body: any) =>
  apiVersionCheck(3) ?
    commonApi.outsourceAccountsLoginWithUrl(body, { toRubby: true })
    :
    ajax({
      url: 'v1/accounts/login_with_url',
      body,
    })

// ===== 版权方（IP 合作）登录/登出/账户 — 独立于供应商，走生成式 api（genapi 由后端 swagger 生成），禁 toRubby 旁路 =====
// 后端前缀：/api/outsource/v2/ip-cooperation/sessions + /accounts（版权方外包端）

export const ipCooperationSessionsLogin = (body: any) =>
  commonApi.ipCooperationSessionsLogin(body)

export const ipCooperationSessionsLogout = () =>
  commonApi.ipCooperationSessionsLogout()

export const ipCooperationAccountsUserInfo = () =>
  commonApi.ipCooperationAccountsUserInfo()

export const ipCooperationAccountsCopyrightOwners = () =>
  commonApi.ipCooperationAccountsCopyrightOwners()

export const ipCooperationAccountsSwitch = (body: any) =>
  commonApi.ipCooperationAccountsSwitchTo(body)

export const ipCooperationAccountsLoginWithUrl = (body: any) =>
  commonApi.ipCooperationAccountsLoginWithUrl(body)